import { req } from 'react-reqq-lite';

import { formatGetQueryParams } from 'modules/common/utils';
import { toastSuccess } from 'modules/common';

import * as c from './constants';
import {
  transformCreateDiscount,
  transformExtraChargesList,
  transformGetDiscountsList,
  transformGetVAT,
  transformUpdateExtraChargesPayload,
  transformVATPayload,
  transformGetTaxChargesList,
} from './transformers';

export const getTaxCharges = ({ params } = {}, cb) =>
  req.get({
    url: '/v1/me/settings/group/TAX_CHARGES',
    key: c.GET_TAX_CHARGES,
    params: formatGetQueryParams(params || {}),
    transform: ({ data, meta }) => ({
      list: data?.map(transformGetTaxChargesList),
      pagination: meta?.pagination,
    }),
    onSuccess: (res) => {
      cb?.(res);
    },
  });

export const getExtraCharges = ({ params } = {}, cb) =>
  req.get({
    url: '/v1/me/settings/group/FEES_CHARGES',
    key: c.GET_EXTRA_CHARGES,
    params: formatGetQueryParams(params || {}),
    transform: ({ data, meta }) => ({
      list: data?.map(transformExtraChargesList),
      pagination: meta?.pagination,
    }),
    onSuccess: (res) => {
      cb?.(res);
    },
  });

export const getVAT = ({ params, uuid } = {}, cb) =>
  req.get({
    url: `/v1/me/settings/key/${uuid}`,
    key: c.GET_VAT,
    params: formatGetQueryParams(params),
    transform: ({ data }) => transformGetVAT(data),
    onSuccess: (res) => {
      cb?.(res);
    },
  });

export const updateVAT = ({ payload, uuid } = {}, cb) =>
  req.put({
    url: `/v1/me/settings/key/${uuid}`,
    key: c.UPDATE_VAT,
    payload: transformVATPayload(payload),
    onSuccess: (res) => {
      toastSuccess('VAT updated successfully.');
      cb?.(res);
    },
  });

export const createVAT = ({ payload } = {}, cb) =>
  req.post({
    url: '/v1/me/settings/key',
    key: c.CREATE_VAT,
    payload: transformVATPayload(payload),
    onSuccess: (res) => {
      toastSuccess('VAT created successfully.');
      cb?.(res);
    },
  });

export const getDiscounts = ({ params } = {}, cb) =>
  req.get({
    url: '/v1/me/settings/group/DISCOUNTS',
    key: c.GET_DISCOUNTS,
    params: formatGetQueryParams(params),
    transform: ({ data, meta }) => ({
      list: data?.map(transformGetDiscountsList),
      pagination: meta?.pagination,
    }),
    onSuccess: (res) => {
      cb?.(res);
    },
  });

export const updateExtraCharges = ({ payload } = {}, cb) =>
  req.patch({
    url: '/v1/me/settings/group/FEES_CHARGES',
    key: c.UPDATE_EXTRA_CHARGES,
    payload: transformUpdateExtraChargesPayload(payload),
    onSuccess: (res) => {
      toastSuccess('Extra Charge updated successfully.');
      cb?.(res);
    },
  });

export const deleteExtraCharges = ({ uuid } = {}, cb) =>
  req.remove({
    url: `/v1/me/settings/key/${uuid}`,
    key: c.DELETE_EXTRA_CHARGES,
    onSuccess: (res) => {
      toastSuccess('Extra Charge deleted successfully.');
      cb?.(res);
    },
  });

export const createDiscount = ({ payload } = {}, cb) =>
  req.post({
    url: `/v1/me/settings/key`,
    key: c.CREATE_DISCOUNT,
    payload: transformCreateDiscount(payload),
    onSuccess: (res) => {
      toastSuccess('Discount added successfully.');
      cb?.(res);
    },
  });

export const updateDiscount = ({ payload, uuid } = {}, cb) =>
  req.put({
    url: `/v1/me/settings/key/${uuid}`,
    key: c.UPDATE_DISCOUNT,
    payload: transformCreateDiscount(payload),
    onSuccess: (res) => {
      toastSuccess('Discount updated successfully.');
      cb?.(res);
    },
  });

export const removeDiscount = ({ uuid } = {}, cb) =>
  req.remove({
    url: `/v1/me/settings/key/${uuid}`,
    key: c.REMOVE_DISCOUNT,
    onSuccess: (res) => {
      toastSuccess('Discount deleted successfully.');
      cb?.(res);
    },
  });
